import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      component: () => import("../views/login.vue"),
      name: "login",
    },
    {
      path: "/home",
      component: () => import("../views/home.vue"),
      name: "home",
      children: [
        {
          path: "artcol",
          component: () => import("../views/artcol.vue"),
          name: "artcol",
          props: true,
          meta: {
            nav: "artcol",
          },
        },
        {
          path: "artup",
          component: () => import("../views/artup.vue"),
          name: "artup",
          meta: {
            nav: "artup",
          },
        },
        {
          path: "artlocalpre",
          component: () => import("../components/artlocalpre.vue"),
          name: "artlocalpre",
          meta: {
            nav: "artup",
          },
        },
        {
          path: "me",
          component: () => import("../views/me.vue"),
          name: "me",
          meta: {
            nav: "me",
          },
          children: [
            {
              path: "settings",
              component: () => import("../components/me/settings.vue"),
            },
          ],
        },
        {
          path: "artpre",
          component: () => import("../components/artpre.vue"),
          name: "artpre",
          meta: {
            nav: "artcol",
          },
        },
        {
          path: "artedit",
          component: () => import("../components/artedit.vue"),
          name: "artedit",
          meta: {
            nav: "artcol",
          },
        },
        {
          path: "clsmag",
          component: () => import("../components/clsmag.vue"),
          name: "clsmag",
          meta: {
            nav: "me",
          },
        },
        {
          path: "artdetail",
          component: () => import("../components/artdetail.vue"),
          name: "artdetail",
          props: true,
          meta: {
            keepAlive: false, // 不缓存
            nav: "me",
          },
        },
        {
          path: "artmag",
          component: () => import("../components/artmag.vue"),
          name: "artmag",
          meta: {
            nav: "me",
            keepAlive: false,
          },
        },
        {
          path: "friends",
          component: () => import("../components/friends.vue"),
          name: "friends",
          meta: {
            nav: "me",
          },
        },
        {
          path: "artshare",
          component: () => import("../components/artshare.vue"),
          name: "artshare",
          meta: {
            nav: "me",
          },
        },
        {
          path: "sharemag",
          component: () => import("../components/sharemag.vue"),
          name: "sharemag",
          meta: {
            nav: "me",
          },
        },
        {
          path: "managefriend",
          component: () => import("../components/managefriend.vue"),
          name: "managefriend",
          meta: {
            nav: "me",
          },
        },
        {
          path: "feedback",
          component: () => import("../components/feedback.vue"),
          name: "feedback",
          meta: {
            nav: "me",
          },
        },
        {
          path: "artlocaledit",
          component: () => import("../components/artlocaledit.vue"),
          name: "artlocaledit",
          meta: {
            nav: "artup",
          },
        },
        {
          path: "addfriend",
          component: () => import("../components/addfriend.vue"),
          name: "addfriend",
          meta: {
            nav: "me",
          },
        },
        {
          path: "mymsg",
          component: () => import("../components/mymsg.vue"),
          name: "mymsg",
          meta: {
            nav: "me",
          },
        },
        {
          path: "mygroup",
          component: () => import("../components/mygroup.vue"),
          name: "mygroup",
          meta: {
            nav: "me",
          },
        },
        {
          path: "mychat",
          component: () => import("../components/mychat.vue"),
          name: "mychat",
          meta: {
            nav: "me",
          },
        },
      ],
    },

    //  {
    //    path: '/ndetail',
    // meta: {
    //   keepAlive: true, //添加这个作为标志符，表明该页面需要保留状态
    // },
    //    component: () => import('../components/ndetail.vue'),
    //    name: 'ndetail',
    //  }
  ],
});
